document.addEventListener('DOMContentLoaded', function() {
  const header = document.querySelector('.cm-header-section');
  const root = document.getElementById('cm-desktop-menu-drawer-root');
  const trigger = document.getElementById('cm-open-desktop-drawer');
  const closeTrigger = document.getElementById('cm-close-desktop-drawer');
  const overlay = document.getElementById('cm-desktop-drawer-overlay');
  const linksWithChildren = document.querySelectorAll('.cm-has-children');
  const linksWithGrandchildren = document.querySelectorAll('.cm-has-grandchildren');
  const subPanels = document.querySelectorAll('.cm-desktop-menu-drawer-sub-panel');
  const remoteTriggers = document.querySelectorAll('.cm-remote-trigger');
  const backButtons = document.querySelectorAll('.cm-sub-panel-back');

  function handleHeaderScroll() {
    if (window.scrollY > 20) {
      header.classList.add('cm-header-scrolled');
    } else {
      header.classList.remove('cm-header-scrolled');
    }
  }

  window.addEventListener('scroll', handleHeaderScroll);
  handleHeaderScroll();

  function closeAll() {
    root.classList.remove('cm-desktop-menu-drawer-active');
    document.body.classList.remove('cm-desktop-menu-drawer-no-scroll');
    const delay = window.innerWidth <= 768 ? 400 : 0;
    setTimeout(() => {
      subPanels.forEach(p => p.classList.remove('cm-is-active'));
    }, delay);
  }

  if (trigger) trigger.addEventListener('click', () => {
    root.classList.add('cm-desktop-menu-drawer-active');
    document.body.classList.add('cm-desktop-menu-drawer-no-scroll');
  });

  if (overlay) overlay.addEventListener('click', closeAll);
  if (closeTrigger) closeTrigger.addEventListener('click', closeAll);

  // Generel tilbage-knap logik
  backButtons.forEach(btn => {
    btn.addEventListener('click', function() {
      this.closest('.cm-desktop-menu-drawer-sub-panel').classList.remove('cm-is-active');
    });
  });

  // Niveau 1 -> Niveau 2
  linksWithChildren.forEach(link => {
    link.addEventListener('click', function() {
      const menuId = this.getAttribute('data-menu-id');
      // Luk alle paneler først for at nulstille
      subPanels.forEach(p => p.classList.remove('cm-is-active'));
      document.getElementById(menuId).classList.add('cm-is-active');
    });
  });

  // Niveau 2 -> Niveau 3 (Nyt setup)
  linksWithGrandchildren.forEach(link => {
    link.addEventListener('click', function() {
      const grandchildId = this.getAttribute('data-grandchild-id');
      // Luk eventuelle andre niveau 3 paneler der måtte være åbne
      document.querySelectorAll('.cm-level-3').forEach(p => p.classList.remove('cm-is-active'));
      document.getElementById(grandchildId).classList.add('cm-is-active');
    });
  });

  remoteTriggers.forEach(btn => {
    btn.addEventListener('click', function() {
      const title = this.getAttribute('data-trigger-title').toLowerCase();
      root.classList.add('cm-desktop-menu-drawer-active');
      const drawerLink = Array.from(linksWithChildren).find(link => 
        link.getAttribute('data-link-title').toLowerCase() === title
      );
      if (drawerLink) drawerLink.click();
    });
  });
});